import { fork, all } from 'redux-saga/effects'

import authSagas from './auth-sagas';
import userSagas from './user-sagas';
import projectSagas from './project-sagas';
import fileSagas from './file-sagas';
import taskGroupsSagas from './task-group-sagas';
import taskSagas from './task-sagas';
import milestoneSagas from './milestone-sagas';
import labelSagas from './label-sagas';
import notificationSagas from './notification-sagas';
import discussionSagas from './discussion-sagas';
import messageSagas from './message-sagas';
import docSagas from './doc-sagas';
import sidebarSagas from './sidebar-sagas';
import flyoutSagas from './flyout-sagas';
import teamChatSagas from './team-chat-sagas';
import appPropsSagas from './app-props-sagas';
import subscriptionSagas from './subscription-sagas';
import teamSagas from './team-sagas';
import tokenSagas from './token-sagas';
import projectTemplatesSagas from './project-templates-sagas';
import timeTrackingSagas from './time-tracking-sagas';
import billingSagas from './billing-sagas';
import customFieldsSagas from './custom-fields-sagas';
import tourSagas from './tour-sagas';
import subteamSagas from './subteam-sagas';
import recursionRuleSagas from './recursion-rule-sagas';
import externalAccountSagas from './external-account-sagas';
import externalCalendarSagas from './external-calendar-sagas';
import userStateSagas from './user-state-sagas';
import embedSagas from './embed-sagas';
import folderSagas from './folder-sagas';
import connectedAccountSagas from './connected-account-sagas';
import roleSagas from './role-sagas';
import automationSagas from './automation-sagas';
import activitySagas from './activity-sagas';
import annotationSagas from './annotation-sagas';
import connectedCalendarsSagas from './connected-calendars-sagas';
import favoriteSagas from './favorite-sagas';
import tasksViewSagas from './tasks-view-sagas';
import formSagas from './form-sagas';
import appSagas from './app-sagas';
import templateSagas from './template-sagas';

const sagas = [
    ...authSagas,
    ...userSagas,
    ...projectSagas,
    ...fileSagas,
    ...taskGroupsSagas,
    ...taskSagas,
    ...milestoneSagas,
    ...labelSagas,
    ...notificationSagas,
    ...discussionSagas,
    ...messageSagas,
    ...docSagas,
    ...sidebarSagas,
    ...flyoutSagas,
    ...teamChatSagas,
    ...appPropsSagas,
    ...subscriptionSagas,
    ...teamSagas,
    ...tokenSagas,
    ...projectTemplatesSagas,
    ...timeTrackingSagas,
    ...billingSagas,
    ...customFieldsSagas,
    ...tourSagas,
    ...subteamSagas,
    ...recursionRuleSagas,
    ...externalAccountSagas,
    ...externalCalendarSagas,
    ...userStateSagas,
    ...embedSagas,
    ...folderSagas,
    ...connectedAccountSagas,
    ...roleSagas,
    ...automationSagas,
    ...activitySagas,
    ...annotationSagas,
    ...connectedCalendarsSagas,
    ...favoriteSagas,
    ...tasksViewSagas,
    ...formSagas,
    ...appSagas,
    ...templateSagas,
];

export default function* root() {
    yield all(sagas.map(saga => fork(saga)));
}
